// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getSeconds as fn } from "../getSeconds.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getSeconds = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getSeconds;
